/**
 * Contract documents are streamed by a token-authorised route because iframes
 * and anchor downloads never carry the Authorization header.  Mint the token
 * with an authenticated request, then hand the signed URL to the browser.
 */
import api from '@/lib/api';

const API = process.env.REACT_APP_BACKEND_URL;

export async function contractDocUrl(contractId, storagePath, fragment = '') {
  if (!contractId || !storagePath) return '';
  const { data } = await api.get(`/contracts/contracts/${contractId}/documents/token`, {
    params: { path: storagePath },
  });
  return `${API}${data.url}${fragment || ''}`;
}

export async function openContractDoc(contractId, storagePath, fragment = '') {
  // Open the tab synchronously with the click, then redirect it once the signed
  // URL is minted — Safari and Firefox block a window.open that comes after an await.
  const tab = window.open('', '_blank', 'noopener');
  try {
    const url = await contractDocUrl(contractId, storagePath, fragment);
    if (!url) { tab?.close(); return; }
    if (tab) tab.location.href = url;
    else window.open(url, '_blank', 'noopener');
  } catch (e) {
    tab?.close();
    throw e;
  }
}

/**
 * Save a document to disk. Anyone who can open the contract can download it —
 * the same signed URL, asked to come back as an attachment.
 */
export async function downloadContractDoc(contractId, storagePath, fileName) {
  const url = await contractDocUrl(contractId, storagePath);
  if (!url) return;
  const a = document.createElement('a');
  a.href = `${url}&download=1`;
  if (fileName) a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
